import L from 'leaflet';

// icon
import rectRed from '../../../assets/map/marker/rectangle/red.png';
import rectBlue from '../../../assets/map/marker/rectangle/blue.png';
import rectGreen from '../../../assets/map/marker/rectangle/green.png';
import rectYellow from '../../../assets/map/marker/rectangle/yellow.png';
import rectGrey from '../../../assets/map/marker/rectangle/grey.png';
import rectCrimson from '../../../assets/map/marker/rectangle/crimson.png';
import rectOrange from '../../../assets/map/marker/rectangle/orange.png';

const iconRectCrimson = new L.Icon({
  iconUrl: rectCrimson,
  iconSize: [8, 8],
});

const iconRectRed = new L.Icon({
  iconUrl: rectRed,
  iconSize: [8, 8],
});

const iconRectBlue = new L.Icon({
  iconUrl: rectBlue,
  iconSize: [8, 8],
});

const iconRectGreen = new L.Icon({
  iconUrl: rectGreen,
  iconSize: [8, 8],
});

const iconRectYellow = new L.Icon({
  iconUrl: rectYellow,
  iconSize: [8, 8],
});

const iconRectGrey = new L.Icon({
  iconUrl: rectGrey,
  iconSize: [8, 8],
});

const iconRectOrange = new L.Icon({
  iconUrl: rectOrange,
  iconSize: [8, 8],
});

const iconRect = {
  crimson: iconRectCrimson,
  red: iconRectRed,
  blue: iconRectBlue,
  green: iconRectGreen,
  yellow: iconRectYellow,
  grey: iconRectGrey,
  orange: iconRectOrange,
};

export default iconRect;
